






import { Component, Vue } from 'vue-property-decorator'
import Heatmap from '@/components/Heatmap.vue'

@Component({
  components: {
    Heatmap
  }
})
export default class Home extends Vue {}
